import React, { useEffect, useState } from 'react'
import { client } from '@Utils'
import { GradeLogViewer } from './GradeLogViewer'

export const GradeLogListView = ({ queryParams }) => {
  console.log('QUERY PARAMS :: ', queryParams)
  const queryString = new URLSearchParams(queryParams).toString()
  const [gradeLogs, setGradeLogs] = useState([])

  useEffect(() => {
    const fetchGradeLogs = async () => {
      try {
        const resp = await client.get(
          `/account/admin_lti13.getGradeLogs/-/?${queryString}`
        )
        setGradeLogs(resp.data.gradeLogs)
      } catch (err) {
        console.error(err)
        //TODO: Use better error reporting to the UI
        alert(err.response.data.error)
      }
    }
    fetchGradeLogs()
  }, [])
  return (
    <div className="card-myed">
      <h3>Failed Grade Push Attempts:</h3>
      <div id="grade-log-container">
        {gradeLogs.map((gradeLog, i) => (
          <GradeLogViewer key={i} gradeLog={gradeLog} />
        ))}
      </div>
    </div>
  )
}
